exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-content{\r\n  border: none !important;\r\n}\r\n\r\n@media only screen and (max-width: 576px) {\r\n  .main .container-fluid {\r\n    padding: 0;\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main